/*
 * BF26 Early Access - Anmeldung (sections/ll-bf26-early-access.liquid).
 *
 * Schickt die E-Mail an Klaviyos oeffentliche Client-API (nur oeffentlicher Site-Key, kein Geheimnis). Die Liste
 * versendet die Double-Opt-In-Mail. Erst nach der Bestaetigung ist der Kunde "abonniert" - Klaviyo synchronisiert das
 * nach Shopify, Shopify Flow setzt dann den Tag bf_2026_vip. Das Theme setzt selbst keinen Tag.
 *
 * Nach dem Absenden erscheint immer dieselbe Meldung - auch wenn die Adresse schon abonniert oder Kunde ist. Die
 * Section verraet so nicht, wer bereits Kunde ist.
 */
const KLAVIYO_REVISION = "2024-10-15";
const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

const subscribe = async ({ company, list, source, email }) => {
  const response = await fetch(`https://a.klaviyo.com/client/subscriptions/?company_id=${encodeURIComponent(company)}`, {
    method: "POST",
    headers: {
      "content-type": "application/vnd.api+json",
      revision: KLAVIYO_REVISION,
    },
    body: JSON.stringify({
      data: {
        type: "subscription",
        attributes: {
          custom_source: source || "BF26 Early Access",
          profile: {
            data: {
              type: "profile",
              attributes: {
                email,
                // Fuer das Klaviyo-Segment "BF26 Early Access" (Kampagnen, Auswertung)
                properties: { bf26_early_access: true },
              },
            },
          },
        },
        relationships: {
          list: { data: { type: "list", id: list } },
        },
      },
    }),
  });
  if (!response.ok) {
    throw new Error(`Klaviyo ${response.status}`);
  }
};

document.querySelectorAll("[data-ll-ea-form]").forEach((form) => {
  const root = form.closest(".ll-ea");
  const error = form.querySelector("[data-ll-ea-error]");
  const button = form.querySelector("[type='submit']");

  form.addEventListener("submit", async (event) => {
    event.preventDefault();
    const email = (form.elements.email?.value || "").trim();
    const consent = form.elements.consent;

    if (!EMAIL_PATTERN.test(email) || !consent?.checked) {
      error.hidden = false;
      (EMAIL_PATTERN.test(email) ? consent : form.elements.email)?.focus();
      return;
    }

    error.hidden = true;
    button.disabled = true;
    try {
      await subscribe({
        company: form.dataset.company,
        list: form.dataset.list,
        source: form.dataset.source,
        email,
      });

      // Login-Link mit vorausgefuellter E-Mail
      root.querySelectorAll("[data-ll-ea-login]").forEach((link) => {
        const url = new URL(link.href, location.origin);
        url.searchParams.set("login_hint", email);
        link.href = url.pathname + url.search;
      });
      root.querySelector("[data-ll-ea-step='form']").hidden = true;
      const done = root.querySelector("[data-ll-ea-step='done']");
      done.hidden = false;
      done.scrollIntoView({ block: "nearest", behavior: "smooth" });
    } catch (exception) {
      console.error(exception);
      error.hidden = false;
      button.disabled = false;
    }
  });
});

// VIP-Button ohne eigenen Link: zum naechsten Abschnitt der Seite (z. B. Produkte der Kategorie)
document.querySelectorAll("[data-ll-ea-next]").forEach((link) => {
  link.addEventListener("click", (event) => {
    const next = link.closest(".shopify-section")?.nextElementSibling;
    if (next) {
      event.preventDefault();
      next.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  });
});

/*
 * VIP-Leiste (sections/ll-bf26-vip-bar.liquid): in den letzten X Tagen vor dem Ende des Early Access den Countdown
 * statt des Vorrat-Texts zeigen. Ende aus der Konfiguration von snippets/ll-bf26.liquid (#ll-bf26-config, App).
 * Aktualisiert jede Minute. Nach dem Ende blendet assets/ll-bf26.js die Leiste ohnehin aus (data-ll-bf26-when="vip").
 */
const readEnd = () => {
  try {
    return Date.parse(JSON.parse(document.getElementById("ll-bf26-config")?.textContent || "{}").end);
  } catch {
    return NaN;
  }
};

const formatRemaining = (bar, milliseconds) => {
  const minutes = Math.max(0, Math.floor(milliseconds / 60000));
  const days = Math.floor(minutes / 1440);
  const hours = Math.floor((minutes % 1440) / 60);
  const rest = minutes % 60;
  const template = days >= 1 ? bar.dataset.formatDays : bar.dataset.formatHours;
  return (template || "")
    .replace("[t]", days)
    .replace("[h]", hours)
    .replace("[m]", rest);
};

document.querySelectorAll("[data-ll-vb]:not([data-preview])").forEach((bar) => {
  const end = readEnd();
  const days = Number(bar.dataset.days) || 0;
  const text = bar.querySelector("[data-ll-vb-text]");
  const countdown = bar.querySelector("[data-ll-vb-countdown]");
  const time = bar.querySelector("[data-ll-vb-time]");
  if (!Number.isFinite(end) || days <= 0 || !countdown || !time) {
    return;
  }

  const update = () => {
    const remaining = end - Date.now();
    const active = remaining > 0 && remaining <= days * 86400000;
    text.hidden = active;
    countdown.hidden = !active;
    if (active) {
      time.textContent = formatRemaining(bar, remaining);
    }
  };
  update();
  setInterval(update, 60000);
});

// Chips: aktuelle Collection mobil in den sichtbaren Bereich der Leiste schieben (nur horizontal, kein Seiten-Scroll)
document.querySelectorAll("[data-ll-vb-chips]").forEach((list) => {
  const current = list.querySelector(".is-current");
  if (current && list.scrollWidth > list.clientWidth) {
    list.scrollLeft = current.offsetLeft - (list.clientWidth - current.offsetWidth) / 2;
  }
});

// 2B: "Seite neu laden" - nach der Freischaltung (Tag bf_2026_vip) zeigt die Seite die Early-Access-Preise
document.querySelectorAll("[data-ll-ea-reload]").forEach((button) => {
  button.addEventListener("click", () => location.reload());
});
